export const MarketViewsConfig = {
	title: 'MARKET_VIEWS_TITLE_PDF',
	subTitleSection: {
		heading: 'MARKET_VIEWS_DATE_PDF',
		subHeading: 'MARKET_VIEWS_DISCLOSURE_PDF'
	},
	summary: 'MARKET_VIEWS_SUMMARY_PDF', // need special logic to parse this
	assetSectionHeader: 'MARKET_VIEWS_ASSET_SECTION_HEADER_PDF',
	weights: {
		overweight: 'MARKET_VIEWS_LEGEND_OVERWEIGHT_PDF',
		underweight: 'MARKET_VIEWS_LEGEND_UNDERWEIGHT_PDF',
		neutral: 'MARKET_VIEWS_LEGEND_NEUTRAL_PDF'
	},
	disclosure: 'OTHER_SECTION_DISCLOSURE_PDF',
	labels: {
		view: 'HEADER_VIEW',
		region: 'HEADER_REGION',
		commentary: 'HEADER_COMMENTARY'
	},
	assets: []
};
